/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileLocation_geography = {
    readonly countries: ReadonlyArray<{
        readonly name: string | null;
        readonly abbreviation: string | null;
    } | null> | null;
    readonly " $refType": "ProfileLocation_geography";
};
export type ProfileLocation_geography$data = ProfileLocation_geography;
export type ProfileLocation_geography$key = {
    readonly " $data"?: ProfileLocation_geography$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_geography">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileLocation_geography",
  "type": "Geography",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "countries",
      "storageKey": null,
      "args": null,
      "concreteType": "GeographyObject",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "abbreviation",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '7f3d03dcc413e8e1cb947ed93ebf6326';
export default node;
